import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteFooter } from '@/components/generals/site-footer'
import { SiteHeader } from '@/components/generals/site-header'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main-content'
                className='sr-only z-[70] rounded-full bg-gold px-5 py-3 font-semibold text-navy focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Skip to main content
            </a>

            <SiteHeader />

            <main id='main-content' tabIndex={-1} className='flex-1 focus:outline-none'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
